export default "__VITE_ASSET__Du9giC3u__"